<template>
  <section class="containerSubMenu"
    v-if="profilePictureSubMenu"
    :class="{'mobile': mobile}"
    v-click-away="close">
    <ul class="containerSubMenu__list bookFont">
      <li class="containerSubMenu__list--item"
        v-for="(item, index) in messagesToShow"
        :key="index"
      >
        <a class="containerSubMenu__list--item_link" @click.stop.prevent="redirectAction(index)" :href="fullLink(index)">
          <span :class="`icon-grey-${item.icon}`"></span>
          <span class="label">{{item.option}}</span>
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import messagesProfileSubMenu from './messagesProfileSubMenu.json'
import { computed, reactive } from 'vue'

export default {
  name: 'profileSubMenu',
  props: ['profilePictureSubMenu', 'ecCode', 'mobile', 'role'],
  emits: ['close-profile-menu'],
  setup (props, { emit }) {
    const messages = reactive(messagesProfileSubMenu)

    /**
     * @description Return the array to show
     */
    const messagesToShow = computed(() => {
      return messages.items.filter(message => !props.role.includes('External') ? true : message.showForExternalUser && props.role.includes('External') )
    })

    /**
     * @description Return the link to redirect
     * @param item index of the item
     */
    function fullLink (index) {
      return `${messagesToShow.value[index].redirect}${messagesToShow.value[index].option === 'Edit My Profile' ? ('/' + props.ecCode) : ''}`
    }

    /**
     * @description Go page depending option chosen
     * @param index index of the item
     */
    function redirectAction (index) {
      window.open(fullLink(index), messagesToShow.value[index].target ? messagesToShow.value[index].target : '_self');
      emit('close-profile-menu')
    }

    /**
     * @description Emit method to close submenu
     * @param event Dom event
     */
    function close (event) {
      if (!event.target.classList.contains('profilePicture__image')) {
        emit('close-profile-menu')
      }
    }

    return {
      redirectAction,
      close,
      fullLink,
      messagesToShow
    }
  }
}
</script>
